import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import logoIzquierdo from '@/assets/logo_durango.png'
import logoDerecho from '@/assets/logo_salud.jpg'


function getBase64FromImage(imgUrl) {
    return new Promise((resolve) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
            const canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)
            resolve(canvas.toDataURL('image/png'))
        }
        img.src = imgUrl
    })
}

function formatearFecha(fecha) {
    return new Intl.DateTimeFormat('es-MX', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    }).format(new Date(fecha))
}

function formatMayusculas(palabras) {
    return palabras.toUpperCase()
}

function formatearFechaHora(fecha) {
    return new Intl.DateTimeFormat('es-MX', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(new Date(fecha))
}

function campoLinea(doc, label, valor, x, y, anchoLinea = 70) {

    // Label
    doc.text(label, x, y)

    // Valor
    doc.setFont("helvetica", "normal")
    doc.text(valor || "-", x + 30, y)

    // Línea punteada
    doc.setDrawColor(100)
    doc.setLineDash([1, 1])
    doc.line(x + 28, y + 1, x + anchoLinea, y + 1)

    doc.setLineDash([])

    doc.setFont("helvetica", "bold")
}

function campo(doc, label, value, x, y, width, minHeight = 10) {
    const text = value || ''
    const textLines = doc.splitTextToSize(text, width - 2)
    const boxHeight = Math.max(minHeight, textLines.length * 3.4 + 2)

    const pageHeight = doc.internal.pageSize.height
    const marginBottom = 25

    if (y + boxHeight + marginBottom > pageHeight) {
        doc.addPage()
        y = 20
    }

    // Label
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(0, 0, 0)
    doc.text(label, x, y)

    // Texto
    doc.setFontSize(8)
    doc.setTextColor(78, 78, 78)
    doc.setFont('helvetica', 'normal')


    // Caja gris
    doc.setFillColor(245, 245, 245)
    doc.rect(x, y + 1, width, boxHeight, 'F')

    // Texto
    doc.text(textLines, x + 2, y + 5)
    doc.setDrawColor(208, 208, 208)
    doc.setLineWidth(0.3)
    doc.line(x, y + 1 + boxHeight, x + width, y + 1 + boxHeight)

    return y + boxHeight + 6
}


function tituloSeccion(doc, texto, y) {
    doc.setFontSize(9)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(0)
    doc.text(texto.toUpperCase(), 15, y)

    doc.setDrawColor(7, 88, 144)
    doc.setLineWidth(0.4)
    doc.line(15, y + 2, 200, y + 2)

    return y + 8
}

async function generarHojaFisioterapiaSeguimiento(consulta, medico) {
    const doc = new jsPDF('p', 'mm', 'letter')
    const pageWidth = doc.internal.pageSize.getWidth()


    const logo1 = await getBase64FromImage(logoIzquierdo)
    const logo2 = await getBase64FromImage(logoDerecho)

    doc.addImage(logo1, 'PNG', 14, 5, 45, 30)
    doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

    doc.setFontSize(11)
    doc.setFont('helvetica', 'bold')
    doc.text('SERVICIOS DE SALUD DEL ESTADO DE DURANGO', pageWidth / 2, 20, { align: 'center' })
    doc.setFontSize(12)
    doc.text('NOTA SEGUIMIENTO FISIOTERAPIA ', pageWidth / 2, 25, { align: 'center' })



    let y = 38

    // DATOS DEL PACIENTE
    autoTable(doc, {
        startY: y,
        head: [
            [
                {
                    content: "Datos del Paciente",
                    colSpan: 1,
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],

        body: [
            ["Nombre: " +  consulta.nombrePaciente],
            ["Servicio: "+  consulta.servicio],
            ["Edad: "+  consulta.edad],
            ["Género: "+  consulta.genero]
        ],
        styles: {
            fontSize: 8,
            cellPadding: 1
        },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        margin: {
            left: 15   // margen izquierdo
        },

        tableWidth: 110,
    })

    // DATOS DEL MEDICO
    autoTable(doc, {
        startY: y,
        margin: {
            left: 130   // empieza en el tercio restante
        },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 8,
            cellPadding: 1
        },
        tableWidth: 70,
        head: [
            [
                {
                    content: "Fisioterapeuta",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [medico.nombre + ' ' + medico.apellidoPaterno + ' ' +medico.apellidoMaterno ],
        ],
        columnStyles: {
            0: { halign: "center" },
        },
    })

    y = doc.lastAutoTable.finalY += 3;

    // EXPEDIENTE
    autoTable(doc, {
        startY: y,
        margin: {
            left: 130   // empieza en el tercio restante
        },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 8,
            cellPadding: 1
        },
        tableWidth: 32.5,
        head: [
            [
                {
                    content: "No. Expediente",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.expediente],
        ],
        columnStyles: {
            0: { halign: "center" },
        },
    })

    // FECHA
    autoTable(doc, {
        startY: y,
        margin: {
            left: 167.5   // empieza en el tercio restante
        },
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 8,
            cellPadding: 1
        },
        tableWidth: 32.5,
        head: [
            [
                {
                    content: "Fecha",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.fecha],
        ],
        columnStyles: {
            0: { halign: "center" },
        },
    })

    y = doc.lastAutoTable.finalY += 5;

    // EXPLORACION FISICA
    autoTable(doc, {
        startY: y,
        margin: { left: 15, right: 15},
        headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0]
        },
        styles: {
            fontSize: 8,
            cellPadding: 1
        },
        head: [
            [
                {
                    content: "Evolución",
                    styles: {
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 9
                    }
                }
            ]
        ],
        body: [
            [consulta.evolucion],
         
        ],
        columnStyles: {
            0: { halign: "left"},
        },
    })

    y = doc.lastAutoTable.finalY += 2.5
      
  const lineaY = y 
  doc.setFontSize(10)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0)

  doc.line(pageWidth / 2 - 30, lineaY + 25, pageWidth / 2 + 30, lineaY + 25)
  doc.text(formatMayusculas(medico.nombre + ' ' + medico.apellidoPaterno + ' ' + medico.apellidoMaterno), pageWidth / 2, lineaY + 30, { align: 'center' })
  doc.text('Fisioterapeuta', pageWidth / 2, lineaY + 35, { align: 'center' })



    const base64 = doc.output('datauristring')
    return base64
}
export { generarHojaFisioterapiaSeguimiento }